// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { Resources } from '@shared/localizations/Resources';
import { SoundManager } from '@shared/utils/SoundManager';
import TicketViewerTemplate from '@front/templates/TicketViewerTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { TerceraTicketScreen } from '../screen/TerceraTicketScreen';
import { Control } from './Control';
import { Event } from '@shared/commons/cache/Event/Event';
import { EventSource, EventType } from '@shared/commons/cache/Event/EventConstants';
import { EventCache } from '@shared/commons/cache/Event/EventCache';
import { TicketData } from '../UtilsClasses/TicketData';
import { DataCache } from '@shared/commons/DataCache';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { ReportMessageTooltip } from '@shared/utils/ReportMessageTooltip';
import { TooltipType } from '@shared/utils/ReportMessageTooltipTypeEnum';
import { WDSettings } from '../settings/WDGeneralSettings';
// TODO. Refactor.
export class TerceraTicketViewer extends Control {
    constructor() {
        super();
        this.ticketData = null;
        this.queue = [];
        this.ticketLifetime = 5000; // 5 seconds showing dealticket
        this.needInit = true;
    }
    getType() {
        return ControlsTypes.TerceraTicketViewer;
    }
    oncomplete() {
        super.oncomplete();
        this.on('OnClick', this.openTicket);
        this.on('OnClickIdea', this.openLefterTicket); // additional lefter dealticket
    }
    tryRegisterUpdates() {
        if (!this.needInit) {
            return;
        }
        this.needInit = false;
        DataCache.OnReportMessage.Subscribe(this.onReportMessage, this);
        DataCache.OnMessageForTicketViewer.Subscribe(this.ProcessMessageForTicketViewer, this);
    }
    // TODO. Refactor. UGLY.
    onReportMessage(reportMsg) {
        // if (!SessionSettings.view.showDealTickets &&
        //     !SessionSettings.sound.enableSound)
        //     return
        if (!DataCache.Loaded) {
            return;
        }
        if (!WDSettings.showDialTicketsInApplicationTray) {
            return;
        }
        if (reportMsg.SkipOnTicketViewer) {
            return;
        }
        const reportTooltip = new ReportMessageTooltip(reportMsg);
        const reportEvent = EventCache.FromReportMessage(reportMsg);
        const ticket = TerceraTicketScreen.TicketFromEvent(reportEvent);
        ticket.header = reportTooltip.GetHeader();
        ticket.text = reportTooltip.GetText();
        ticket.soundKey = reportTooltip.soundKey;
        ticket.tooltipDrawType = reportTooltip.TooltipDrawType;
        ticket.dealTicketTooltip = !isValidString(reportTooltip.dealTicketTooltip)
            ? reportTooltip.dealTicketTooltip
            : '';
        ticket.showNextTime = WDSettings.openDialTicketsOnWorkspace;
        ReportMessageTooltip.fixEntries(ticket.sortedEntries, SessionSettings, reportMsg.Instrument, reportMsg.account, reportMsg.productType);
        ReportMessageTooltip.localizeEntries(ticket.sortedEntries);
        const needShowMarginDealTicketOnWorkspace = ticket.eventSource === EventSource.MarginCall && WDSettings.showMarginDealTicketOnWorkspace;
        if (needShowMarginDealTicketOnWorkspace || (ticket.isTrade && ticket.showNextTime)) {
            TerceraTicketScreen.show(ticket);
        }
        else {
            this.showTicket(ticket);
        }
    }
    ProcessMessageForTicketViewer(eventData) {
        const ticket = new TicketData();
        ticket.header = '';
        ticket.isTrade = true;
        ticket.header = Resources.getResource('reports.FUNCTION_PRODUCTS_FAILURE');
        ticket.tooltipDrawType = TooltipType.AccountOperation;
        ticket.text = Resources.getResource('BusinessRejectMessage.' + eventData.ErrorCode);
        const product = DataCache.EntitlementManager.ProductsCache[eventData.ReqProductId];
        let productName = '';
        if (!isNullOrUndefined(product)) {
            productName = product.Name;
        }
        ticket.text = ticket.text.replace('{0}', productName);
        ticket.sortedEntries = [
            {
                caption: 'Error',
                text: ticket.text
            }
        ];
        ticket.dealTicketTooltip = ticket.text;
        ticket.showNextTime = WDSettings.openDialTicketsOnWorkspace;
        const ev = new Event({
            DateTime: DateTimeUtils.DateTimeUtcNow(),
            Action: ticket.header,
            Description: ticket.text,
            Source: ticket.eventSource,
            EventType: EventType.Trading
        });
        // GOVNO
        if (!isNullOrUndefined(ev.DescriptionItems[0])) {
            ev.DescriptionItems[0].Value = ticket.text;
        }
        EventCache.Add(ev);
        if (!WDSettings.showDialTicketsInApplicationTray) {
            return;
        }
        const needShowMarginDealTicketOnWorkspace = ticket.eventSource === EventSource.MarginCall && WDSettings.showMarginDealTicketOnWorkspace;
        if (needShowMarginDealTicketOnWorkspace || (ticket.isTrade && ticket.showNextTime)) {
            TerceraTicketScreen.show(ticket);
        }
        else {
            this.showTicket(ticket);
        }
    }
    showTicketWork() {
        if (this.queue.length > 0) {
            this.prepareTicket(this.queue.shift());
            setTimeout(this.showTicketWork.bind(this), this.ticketLifetime);
        }
        else {
            const lastIdeaTicketSetTime = this.get('lastIdeaTicketSetTime');
            const leftTime = lastIdeaTicketSetTime ? this.ticketLifetime - Date.now() + lastIdeaTicketSetTime : 0;
            if (leftTime > 0) {
                setTimeout(this.hideAllTickets.bind(this), leftTime);
            } // время жизни основного тикета закончилось но еще висит тикет идеи
            else {
                this.hideAllTickets();
            }
        }
    }
    ClearQueue() {
        this.queue.length = 0;
        this.hideAllTickets();
    }
    prepareTicket(ticketData) {
        const needToAddToTheLeft = this.needAddToTheLeftTicket(ticketData);
        this.hideCorrectTicket(needToAddToTheLeft);
        this.setStyleClasses(ticketData);
        needToAddToTheLeft ? this.setDataToLeftTicket(ticketData) : this.setDataToTicket(ticketData);
    }
    showTicket(ticketData) {
        if (isNullOrUndefined(ticketData))
            return;
        const visible = this.get('visible');
        if (!visible) {
            this.prepareTicket(ticketData);
            setTimeout(this.showTicketWork.bind(this), this.ticketLifetime);
        }
        else {
            if (ticketData.tooltipDrawType === TooltipType.Idea) {
                this.prepareTicket(ticketData);
            }
            else {
                this.queue.push(ticketData);
            }
        }
        this.tryPlaySound(ticketData);
    }
    openTicket() {
        TerceraTicketScreen.show(this.ticketData);
    }
    openLefterTicket() {
        // событие по нажатию на msg левее основного
        // return // открытие дилтикета с таким же содержимым как в тултипе вероятно и не нужно на десктопе нет
        TerceraTicketScreen.show(this.lefterTicketData);
    }
    setStyleClasses(ticketData) {
        const isIdeaDealTicket = TerceraTicketViewer.isIdeaDealTicket(ticketData);
        const isLefterTicket = this.needAddToTheLeftTicket(ticketData);
        if (isIdeaDealTicket) {
            void this.set(isLefterTicket ? 'headerClassIdea' : 'headerClass', 'js-idea-header');
            void this.set('imageSvg', 'ideas');
        }
        else {
            switch (ticketData.tooltipDrawType) {
                case TooltipType.CAInfo:
                    void this.set({
                        headerClass: 'CAInfo',
                        imageSvg: 'infotool'
                    });
                    break;
                case TooltipType.CAAccepted:
                    void this.set({
                        headerClass: 'CAAccepted',
                        imageSvg: 'accept'
                    });
                    break;
                case TooltipType.CARejected:
                    void this.set({
                        headerClass: 'CARejected',
                        imageSvg: 'closeCrossBtn'
                    });
                    break;
                case TooltipType.CACanceled:
                    void this.set({
                        headerClass: 'CACanceled',
                        imageSvg: 'closeAccountCanceled'
                    });
                    break;
                case TooltipType.Trade:
                    void this.set({
                        headerClass: '',
                        imageSvg: 'infotool'
                    });
                    break;
                case TooltipType.AccountOperation:
                    void this.set({
                        headerClass: 'js-account-operation-header',
                        imageSvg: 'accountOperation'
                    });
                    break;
                default:
                    void this.set({
                        headerClass: 'js-refuse-header',
                        imageSvg: 'infotool'
                    });
                    break;
            }
        }
    }
    setDataToTicket(ticketData) {
        void this.set({
            header: ticketData.header,
            text: ticketData.text,
            dealTicketTooltip: isValidString(ticketData.dealTicketTooltip) ? ticketData.dealTicketTooltip : '',
            visible: true
        });
        this.ticketData = ticketData;
    }
    setDataToLeftTicket(ticketData) {
        void this.set({
            headerIdea: ticketData.header,
            textIdea: ticketData.text,
            dealTicketTooltipIdea: isValidString(ticketData.dealTicketTooltip) ? ticketData.dealTicketTooltip : '',
            visibleIdea: true,
            lastIdeaTicketSetTime: Date.now()
        });
        this.lefterTicketData = ticketData;
    }
    hideAllTickets() {
        void this.set({ visible: false, visibleIdea: false });
    }
    hideCorrectTicket(needToAddToTheLeft) {
        const lastIdeaTicketSetTime = this.get('lastIdeaTicketSetTime');
        if (lastIdeaTicketSetTime &&
            Date.now() - lastIdeaTicketSetTime > this.ticketLifetime) // левый дилтикет не становится в общую очередь, а имеет свой таймер
         {
            void this.set({
                visibleIdea: false,
                lastIdeaTicketSetTime: null
            });
        }
        void this.set(needToAddToTheLeft ? 'visibleIdea' : 'visible', false); // чтобы новый дилтикет выезжал заново а не подменял старый
    }
    // TODO. IMPORTANT. Move to another place.
    tryPlaySound(ticketData) {
        const sndKeys = SoundManager.SoundKeys;
        let key = ticketData.soundKey;
        if (!isValidString(key)) {
            SoundManager.tryPlaySound(sndKeys.OrderRejected);
            return;
        }
        key = key.toLowerCase();
        if (key.includes('refused')) {
            SoundManager.tryPlaySound(sndKeys.OrderRejected);
        }
        else if (key.includes('order created')) {
            SoundManager.tryPlaySound(sndKeys.OrderCreated);
        }
        else if (key.includes('order canceled')) {
            SoundManager.tryPlaySound(sndKeys.OrderCanceled);
        }
        else if (key.includes('order replaced')) {
            SoundManager.tryPlaySound(sndKeys.OrderReplaced);
        }
        else if (key.includes('order rejected')) {
            SoundManager.tryPlaySound(sndKeys.OrderRejected);
        }
        else if (key.includes('modified')) {
            SoundManager.tryPlaySound(sndKeys.Modify);
        }
        else if (key.includes('margin warning')) {
            SoundManager.tryPlaySound(sndKeys.MarginWarning);
        }
        else if (key.includes('order') && key.includes('filled')) {
            SoundManager.tryPlaySound(sndKeys.OrderFilled);
        }
        else if (key.includes('market') && key.includes('order') && key.includes('filled')) {
            SoundManager.tryPlaySound(sndKeys.PostionClose);
        }
    }
    needAddToTheLeftTicket(ticketData) {
        // если основное место занято и там не дилтикет идей добавляем новый левее
        return (TerceraTicketViewer.isIdeaDealTicket(ticketData) &&
            this.get('visible') &&
            !isNullOrUndefined(this.ticketData) &&
            this.ticketData.tooltipDrawType !== TooltipType.Idea);
    }
    static isIdeaDealTicket(ticketData) {
        return !isNullOrUndefined(ticketData) && ticketData.tooltipDrawType === TooltipType.Idea;
    }
}
Control.extendWith(TerceraTicketViewer, {
    template: TicketViewerTemplate,
    data: function () {
        return {
            image: '',
            header: '',
            text: '',
            headerClass: '',
            imageSvg: '',
            dealTicketTooltip: '',
            headerIdea: '', // все что с приставкой Idea относится к дополнительным дилтикетам показываемым левее основных если они есть; пока используем только для дилтикетов торговых идей
            textIdea: '',
            visibleIdea: false,
            headerClassIdea: '',
            dealTicketTooltipIdea: '',
            lastIdeaTicketSetTime: null,
            visible: false
        };
    }
});
